import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative -mt-24 sm:-mt-32 z-40" }
const _hoisted_2 = { class: "container mx-auto px-4 sm:px-6" }
const _hoisted_3 = { class: "py-6 sm:py-8 px-6 sm:px-8 rounded-2xl sm:rounded-3xl shadow-2xl bg-white relative" }
const _hoisted_4 = {
  ref: "statsContainer",
  class: "grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6"
}
const _hoisted_5 = { class: "w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3 mx-auto group-hover:bg-primary/20 transition-all duration-300" }
const _hoisted_6 = { class: "text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-1" }
const _hoisted_7 = { class: "text-xs sm:text-sm text-gray-900 font-medium" }
const _hoisted_8 = { class: "flex justify-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "text-2xl sm:text-3xl md:text-4xl font-bold mb-6 md:mb-8 text-primary text-center" }, "Our Impact", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stat.label,
              class: "text-center group"
            }, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(stat.icon), { class: "w-7 h-7 sm:w-8 sm:h-8 text-primary" }))
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.animatedValues[stat.label]) + _toDisplayString(stat.suffix), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(stat.label), 1)
            ]))
          }), 128))
        ], 512),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/impact'))),
            class: "w-14 h-14 sm:w-16 sm:h-16 bg-primary hover:bg-accent rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group",
            "aria-label": "View all programs"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "w-6 h-6 text-white group-hover:translate-x-1 transition-transform",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M14 5l7 7m0 0l-7 7m7-7H3"
              })
            ], -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/donate'))),
            class: "w-14 h-14 sm:w-16 sm:h-16 bg-accent hover:bg-primary rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group",
            "aria-label": "Support our mission"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "w-6 h-6 text-white transition-transform",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
              })
            ], -1)
          ]))])
        ])
      ])
    ])
  ]))
}